import {Stack, Typography} from '@mui/material';
import {ControlledRadioGroup} from 'presentation/components/ControlledRadioGroup';
import React from 'react';
import {ProviderPreferenceRadioGroupProps} from '../types';
import {radioOptions} from '../constants';

export const ProviderPreferenceRadioGroup: React.FC<ProviderPreferenceRadioGroupProps> = ({
	value,
	onChange,
	error,
}) => (
	<Stack>
		<ControlledRadioGroup
			radioOpts={radioOptions}
			value={value ?? ''}
			onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
				const selectedValue = event.target.value === 'true';
				onChange(selectedValue);
			}}
			forceTextPrimaryColor
			gap={1}
			error={!!error}
		/>
		{error ? (
			<Typography variant="caption" color="error" mt={1}>
				{error}
			</Typography>
		) : null}
	</Stack>
);
